import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { MediaBreakPointUp } from '@lean-body/components/styles';
import { GoalMatchingAssessmentAnswerResponse, KIND_INTERESTING_LESSON, KIND_WEIGHT_GOAL, } from '@lean-body/src/domain';
import { useState, useEffect } from 'react';
import { LocalStorage, LocalStorageType } from '@lean-body/src/infra';
import { GOAL_MATCHING_ASSESSMENT_VERSION } from '../pages/main_goal_matching_assessment';
import { GoalMatchingAssessmentForm } from './goal_matching_assessment_form';
import { PageLoading } from './page_loading';
import { GoalMatchingAssessmentResult } from './goal_matching_assessment_result';
import { GoalMatchingAssessmentStartPage } from './goal_matching_assessment_start_page';
import { GoalMatchingAssessmentDiagnosisStartPage } from './goal_matching_assessment_diagnosis_start_page';
import { MatchingAssessmentDiagnosis } from './matching_assessment_diagnosis';
import { MatchingAssessmentDiagnosisPlanResult } from './matching_assessment_diagnosis_plan_result';
import { matchingAssessmentDiagnosisFlow } from '@lean-body/src/domain/matching_assessment_diagnosis_steps';
export const GoalMatchingAssessment = ({ apiClient, config, tracker, setProfile, assessments, pastAnswers, isReassessment, showStartPage, skipToKind, signupFlow = false, onSignupFlowComplete, }) => {
    const localStorage = new LocalStorage();
    const [isShowStartPage, setIsShowStartPage] = useState(showStartPage);
    const [isShowDiagnosis, setIsShowDiagnosis] = useState(false);
    const [showResultsPage, setShowResultsPage] = useState(false);
    const [diagnosisInitialProgressCurrent, setDiagnosisInitialProgressCurrent] = useState(0);
    const [assessmentIndex, setAssessmentIndex] = useState(0);
    const [currentAnswers, setCurrentAnswers] = useState([]);
    const diagnosisStepCount = matchingAssessmentDiagnosisFlow.length;
    const progressQuestionCount = signupFlow ? diagnosisStepCount + assessments.length : assessments.length;
    const progressCurrent = signupFlow ? diagnosisStepCount + assessmentIndex : assessmentIndex;
    // 診断の表示や結果画面で使われる
    const [userName, setUserName] = useState('');
    const [activityLevel, setActivityLevel] = useState();
    const [gender, setGender] = useState();
    const [birthday, setBirthday] = useState('');
    const [currentHeight, setCurrentHeight] = useState();
    const [currentWeight, setCurrentWeight] = useState();
    const [weightGoal, setWeightGoal] = useState();
    const [weightGoalPaceId, setWeightGoalPaceId] = useState();
    const [isWeightKeeping, setIsWeightKeeping] = useState(false);
    useEffect(() => {
        if (skipToKind) {
            const idx = findAssessmentIndexByKind(skipToKind);
            setAssessmentIndex(idx);
            applyPastAnswers(idx, pastAnswers);
        }
    }, []);
    const setAssessmentInfo = (assessment, answer) => {
        if (assessment.isKindGender) {
            setGender(answer.choiceIds[0]);
        }
        else if (assessment.isKindActivityLevel) {
            setActivityLevel(answer.choiceIds[0]);
        }
        else if (assessment.isKindUserName) {
            setUserName(answer.textInput);
        }
        else if (assessment.isKindBirthday) {
            setBirthday(answer.textInput);
        }
        else if (assessment.isKindHeight) {
            setCurrentHeight(Number(answer.textInput));
        }
        else if (assessment.isKindWeight) {
            setCurrentWeight(Number(answer.textInput));
        }
        else if (assessment.isKindWeightGoal) {
            const value = Number(answer.textInput);
            setWeightGoal(value);
            setIsWeightKeeping(currentWeight === value);
        }
        else if (assessment.isKindWeightGoalPace) {
            setWeightGoalPaceId(answer.choiceIds[0]);
        }
    };
    // kindで特定の質問indexを取得する
    const findAssessmentIndexByKind = (kind) => {
        return assessments.findIndex((assessment) => assessment.kind === kind);
    };
    // indexまで過去の回答を反映する
    const applyPastAnswers = (idx, pastAnswers) => {
        const answers = [];
        assessments.slice(0, idx).forEach((assessment, index) => {
            const pastAnswer = pastAnswers.find((answer) => assessment.id === answer.matchingAssessmentId);
            let answer = GoalMatchingAssessmentAnswerResponse.createEmptyParam(assessment);
            if (pastAnswer) {
                answer = pastAnswer.toParam();
                setAssessmentInfo(assessment, answer);
            }
            answers[index] = answer;
        });
        setCurrentAnswers(answers);
    };
    const onDiagnosisComplete = () => {
        setIsShowDiagnosis(false);
    };
    const onClickNext = () => {
        var _a;
        if (isShowStartPage) {
            setIsShowStartPage(false);
            if (signupFlow) {
                setDiagnosisInitialProgressCurrent(0);
                setIsShowDiagnosis(true);
            }
            return;
        }
        setAssessmentInfo(assessments[assessmentIndex], currentAnswers[assessmentIndex]);
        // 現状維持の場合コース日選択まで飛ばす（目標ペース、アプローチはスキップ）
        if (assessments[assessmentIndex].isKindWeightGoal) {
            const weightGoal = Number((_a = currentAnswers[assessmentIndex]) === null || _a === void 0 ? void 0 : _a.textInput);
            if (currentWeight === weightGoal) {
                const idx = findAssessmentIndexByKind(KIND_INTERESTING_LESSON);
                setAssessmentIndex(idx);
                return;
            }
        }
        const isFinished = assessmentIndex === assessments.length - 1;
        if (isFinished) {
            if (signupFlow) {
                const courseCode = localStorage.loadObjByKey(LocalStorageType.CourseCode);
                localStorage.saveGoalMatchingAssessmentParams({
                    answers: currentAnswers,
                    version: GOAL_MATCHING_ASSESSMENT_VERSION,
                    courseCode,
                });
            }
            setShowResultsPage(true);
        }
        else {
            setAssessmentIndex(assessmentIndex + 1);
        }
    };
    const onClickBack = () => {
        if (assessmentIndex === 0) {
            if (signupFlow) {
                setDiagnosisInitialProgressCurrent(diagnosisStepCount - 1);
                setIsShowDiagnosis(true);
            }
            else {
                setIsShowStartPage(true);
            }
            return;
        }
        // 現状維持の場合、目標ペース、アプローチの質問を飛ばすため
        if (isWeightKeeping && assessments[assessmentIndex].isKindInterestingLesson) {
            const idx = findAssessmentIndexByKind(KIND_WEIGHT_GOAL);
            setAssessmentIndex(idx);
            return;
        }
        setAssessmentIndex(assessmentIndex - 1);
    };
    const onClickBackForResult = () => {
        setShowResultsPage(false);
    };
    if (!assessments) {
        return React.createElement(PageLoading, null);
    }
    return (React.createElement("div", { className: css(styles.container) }, isShowStartPage ? (signupFlow ? (React.createElement(GoalMatchingAssessmentDiagnosisStartPage, { onClickNext: onClickNext })) : (React.createElement(GoalMatchingAssessmentStartPage, { onClickNext: onClickNext }))) : isShowDiagnosis ? (React.createElement(MatchingAssessmentDiagnosis, { config: config, tracker: tracker, onDiagnosisComplete: onDiagnosisComplete, onBack: () => setIsShowStartPage(true), progressQuestionCount: progressQuestionCount, initialProgressCurrent: diagnosisInitialProgressCurrent })) : showResultsPage ? (signupFlow ? (React.createElement(MatchingAssessmentDiagnosisPlanResult, { apiClient: apiClient, tracker: tracker, userName: userName, currentWeight: currentWeight, currentAnswers: currentAnswers, isWeightKeeping: isWeightKeeping, onBack: onClickBackForResult, onComplete: onSignupFlowComplete })) : (React.createElement(GoalMatchingAssessmentResult, { apiClient: apiClient, config: config, userName: userName, currentAnswers: currentAnswers, isWeightKeeping: isWeightKeeping, isReassessment: isReassessment, setProfile: setProfile, onClickBackForResult: onClickBackForResult, classObject: styles.contentForResult }))) : (React.createElement("div", { className: css(styles.content) },
        React.createElement(GoalMatchingAssessmentForm, { apiClient: apiClient, config: config, index: assessmentIndex, progressCurrent: progressCurrent, progressQuestionCount: progressQuestionCount, matchingAssessment: assessments[assessmentIndex], pastAnswers: pastAnswers, currentAnswers: currentAnswers, activityLevel: activityLevel, gender: gender, birthday: birthday, currentHeight: currentHeight, currentWeight: currentWeight, weightGoal: weightGoal, weightGoalPaceId: weightGoalPaceId, onClickNext: onClickNext, onClickBack: onClickBack, showProgress: !isReassessment })))));
};
const styles = StyleSheet.create({
    container: {
        position: 'relative',
        height: '100%',
        paddingTop: 50,
        [MediaBreakPointUp.MD]: {
            paddingTop: 0,
        },
    },
    content: {
        display: 'flex',
        justifyContent: 'center',
        padding: '30px 24px 120px',
        [MediaBreakPointUp.MD]: {
            padding: 0,
        },
    },
    contentForResult: {
        padding: '30px 24px',
        [MediaBreakPointUp.MD]: {
            padding: '0 0 14px',
        },
    },
});
